import React from "react"
import { concatStrings } from "../utilities"

export const StatusColor = {
  RED: "red",
  ORANGE: "orange",
  GREEN: "green",
  GREY: "grey", // default color
}

const explicitColors = [
  StatusColor.GREEN, StatusColor.ORANGE, StatusColor.RED
]

const CStatusDot = ({ status, add_class }) => {
  const baseClass = "c-StatusDot"

  return (
    <div
      className={concatStrings(
        baseClass,
        explicitColors.indexOf(status) >= 0 ? `${baseClass}--${status}` : "",
        add_class)}
    />
  )
}

export default CStatusDot
